var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { md: "12" } }, [
        _c(
          "div",
          [
            _c(
              "table",
              {
                staticClass: "table b-table",
                class: _vm.listCertificates.length
                  ? "b-table-selectable b-table-select-single"
                  : "",
                attrs: { relative: "" },
              },
              [
                _c("thead", { attrs: { role: "rowgroup" } }, [
                  _c("tr", { attrs: { role: "row" } }, [
                    _c(
                      "th",
                      {
                        staticClass: "text-center table-condensed-ipad",
                        attrs: { role: "columnheader" },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.security.cert_name")))]
                    ),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c(
                          "th",
                          {
                            staticClass:
                              "text-center table-condensed-ipad col-1",
                            attrs: { role: "columnheader" },
                          },
                          [_vm._v(_vm._s(_vm.$t("rights.edit")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canDelete
                      ? _c(
                          "th",
                          {
                            staticClass:
                              "text-center table-condensed-ipad col-1",
                            attrs: { role: "columnheader" },
                          },
                          [_vm._v(_vm._s(_vm.$t("rights.delete")))]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { attrs: { role: "rowgroup" } },
                  [
                    _vm.activateSpinner
                      ? _c("tr", { attrs: { role: "row" } }, [
                          _c(
                            "td",
                            {
                              staticClass: "text-center py-0",
                              attrs: { role: "cell", colspan: "3" },
                            },
                            [_c("spinner", {})],
                            1
                          ),
                        ])
                      : _vm.listCertificates.length
                      ? _vm._l(
                          _vm.listCertificates,
                          function (certificate, index) {
                            return _c(
                              "tr",
                              {
                                key: "certificate-" + index,
                                attrs: { role: "row" },
                                on: {
                                  click: function ($event) {
                                    return _vm.actionDetails(
                                      $event,
                                      certificate.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    attrs: { role: "cell" },
                                  },
                                  [_vm._v(_vm._s(certificate.name))]
                                ),
                                _vm._v(" "),
                                _vm.canEdit
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        attrs: { role: "cell" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionEdit(
                                              $event,
                                              certificate.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-pencil",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canDelete
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        attrs: { role: "cell" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionDelete(
                                              $event,
                                              certificate.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-trash",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        )
                      : _c(
                          "tr",
                          { staticClass: "no-hover", attrs: { role: "row" } },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "text-center font-weight-bold",
                                attrs: { role: "cell", colspan: "3" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("common.security.no_result")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _vm.canAdd
              ? _c(
                  "b-row",
                  { staticClass: "justify-content-end mt-4 no-gutter" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.actionAdd },
                      },
                      [
                        _c("span", { staticClass: "d-none d-xl-inline" }, [
                          _vm._v(_vm._s(_vm.$t("common.security.add_cert"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }